<template>
  <div class="ts-flex ts-space-x-3">
    <div class="ts-w-full">
      <h2 class="ts-text-lg ts-uppercase ts-pl-4">
        {{ $t('projectProfile.description') }}
      </h2>
      <p class="ts-pl-4">{{ resources.project_description }}</p>
      <div class=" ts-pl-3 ts-mt-10">
        <table class="ts-w-full">
          <tbody>
            <tr class="ts-border-b ts-border-t">
              <td
                class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
              >
                {{ $t('projectProfile.code') }}
              </td>
              <td class="ts-px-3 ts-w-3/12">
                {{ resources.project_code }}
              </td>
              <td
                class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
              >
                {{ $t('projectProfile.status') }}
              </td>
              <td class="ts-px-3 ts-w-3/12">
                {{ resources.project_status }}
              </td>
            </tr>
            <tr class="ts-border-b ts-border-t">
              <td
                class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
              >
                {{ $t('projectProfile.estimatedStartDate') }}
              </td>
              <td class="ts-px-3 ts-w-3/12">
                {{ resources.estimated_start_date }}
              </td>
              <td
                class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
              >
                {{ $t('projectProfile.priority') }}
              </td>
              <td class="ts-px-3 ts-w-3/12">
                {{ resources.label }}
              </td>
            </tr>
            <tr class="ts-border-b ts-border-t">
              <td
                class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
              >
                {{ $t('projectProfile.estimatedEndDate') }}
              </td>
              <td class="ts-px-3 ts-w-3/12">
                {{ resources.estimated_end_date }}
              </td>

              <td
                class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
              >
                {{ $t('projectProfile.owner') }}
              </td>
              <td class="ts-px-3 ts-w-3/12">
                {{ resources.owner_name_en }}
              </td>
            </tr>
            <tr class="ts-border-b ts-border-t">
              <td
                class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
              >
                {{ $t('projectProfile.actualStartDate') }}
              </td>
              <td class="ts-px-3 ts-w-3/12">
                {{ resources.actual_start_date }}
              </td>

              <td
                class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
              >
                {{ $t('projectProfile.customer') }}
              </td>
              <td class="ts-px-3 ts-w-3/12">
                {{ resources.customer_name }}
              </td>
            </tr>
            <tr class="ts-border-b ts-border-t">
              <td
                class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
              >
                {{ $t('projectProfile.actualEndDate') }}
              </td>
              <td class="ts-px-3 ts-w-3/12">
                {{ resources.actual_end_date }}
              </td>

              <td
                class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
              >
                {{ $t('projectProfile.customerContact#') }}
              </td>
              <td class="ts-px-3 ts-w-3/12">
                {{ resources.customer_contact_number }}
              </td>
            </tr>
            <tr class="ts-border-b ts-border-t">
              <td
                class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
              >
                {{ $t('projectProfile.createdBy') }}
              </td>
              <td class="ts-px-3 ts-w-3/12">
                {{ resources.created_by_name }}
              </td>
              <td
                class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
              >
                {{ $t('projectProfile.address') }}
              </td>
              <td class="ts-px-3 ts-w-3/12">
                {{ resources.project_address }}
              </td>
            </tr>
            <tr class="ts-border-b ts-border-t">
              <td
                class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
              >
                {{ $t('projectProfile.createdAt') }}
              </td>
              <td class="ts-px-3 ts-w-3/12">
                {{ resources.created_at }}
              </td>
            </tr>
          </tbody>
        </table>
        <div class="ts-w-full ts-col-span-3 ts-pl-2">
          <h2 class=" ts-mt-6 ts-text-lg ts-uppercase">
            {{ $t('projectProfile.attachment') }}
          </h2>
          <div class="ts-pl-3 ts-mt-3">
            <ul>
              <li v-for="(att, index) in resources.attachments" :key="index">
                <button
                  class="ts-mr-2 hover:ts-text-red-600"
                  @click.prevent="deleteRecord(att.id)"
                >
                  <Icon type="ios-trash-outline" size="18" />
                </button>
                <a href="#" @click.prevent="onClickViewFile(att)">{{
                  att.file_name
                }}</a>
                {{ $t('projectProfile.createdBy') }} <b>{{ att.name }}</b>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  props: ['resources'],
  methods: {
    ...mapActions('projectMgt/projectMilestone', ['deleteAttachment']),
    deleteRecord(id) {
      this.$confirm({
        title: this.$t('task.are_you_want_to_delete_it_cant_redo'),
        okText: this.$t('yes'),
        okType: 'danger',
        cancelText: this.$t('no'),
        centered: true,
        onOk: () => {
          return this.deleteAttachment(id)
            .then(response => {
              this.$emit('fetch')
              return Promise.resolve(response)
            })
            .catch(error => {
              this.$toasted.error(error.message)
              return Promise.reject(error)
            })
        },
        onCancel() {}
      })
    },
    onClickViewFile(att) {
      window.open(att.file_path, '_blank', 'noreferrer')
    }
  }
}
</script>
